import styled from 'styled-components/macro';
import { Table, Download } from '~/components';

export const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-bottom: 50px;
  flex: 1;
  min-height: 100%;
  background-color: ${({ theme }) => theme.white};
  &:before {
    content: ' ';
    position: absolute;
    background-color: ${({ theme }) => theme.dark5};
    width: 187px;
    height: 100%;

    @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
      width: 72px;
    }
  }
`;

export const TableCountdown = styled(Table)`
  width: 100%;
  & > table {
    width: 100%;
    & > thead {
      display: none;
      @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
        display: none;
      }
    }
    td {
      font-size: ${({ theme }) => theme.h5}px;
      font-family: ${({ theme }) => theme.primaryFontMedium};

      &:first-child {
        position: relative;
        width: 187px;
        background-color: ${({ theme }) => theme.blue2};
        color: ${({ theme }) => theme.white};
        text-align: right;
        font-family: ${({ theme }) => theme.primaryFontMedium};
        font-size: ${({ theme }) => theme.h5}px;
        padding: 0;
        & > div {
          display: inline-block;
          width: 100%;
          padding: 16px 13px;
          position: relative;
          color: ${({ theme }) => theme.white};

          @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
            max-width: 100%;
            line-height: 1;
            text-align: left;
          }

          @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
            width: 71px;
          }
        }

        @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
          width: 71px;
          font-size: ${({ theme }) => theme.label}px;
        }
      }
      &:nth-child(2) {
        padding-left: 33px;
        padding-right: 33px;
        width: 187px;
        & > div {
          @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
            line-height: 1;
          }
        }

        @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
          padding: 13px;
          width: 71px;
          font-family: ${({ theme }) => theme.primaryFontMedium};
          font-size: ${({ theme }) => theme.label}px;
        }
      }
      &:nth-child(3) {
        font-family: ${({ theme }) => theme.primaryFontMedium};
        font-size: ${({ theme }) => theme.h5}px;

        & > div {
          @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
            line-height: 1;
          }
        }

        @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
          font-family: ${({ theme }) => theme.primaryFontMedium};
          font-size: ${({ theme }) => theme.label}px;
        }
      }
    }
  }
`;

export const DownloadButton = styled(Download)`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 187px 187px auto;
  background-color: ${({ theme, competition }) =>
    competition === 1 ? theme.coral : theme.turquoise};
  height: 38px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  z-index: 10;
  position: sticky;
  top: 0px;
  color: ${({ theme }) => theme.white};
  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    grid-template-columns: 71px 91px auto;
  }
`;

export const Th = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-family: ${({ theme }) => theme.primaryFont};
  font-size: ${({ theme }) => theme.paragraph}px;
  text-transform: uppercase;
  margin-right: 1vw;

  &:nth-child(2) {
    justify-content: flex-start;
    margin-left: 33px;
  }

  &:last-child {
    justify-content: center;
    margin: 0;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    font-size: ${({ theme }) => theme.paragraphSmall}px;
    margin: 0 0 0 13px !important;
    justify-content: flex-start;
  }
`;

export const TableSeparator = styled.div`
  width: calc(100% - 60px);
  height: 1px;
  background: -webkit-linear-gradient(
    left,
    ${({ theme }) => theme.white},
    ${({ theme }) => theme.white} 157px,
    ${({ theme }) => theme.gray4} 158px,
    ${({ theme }) => theme.gray4}
  );
  background: -moz-linear-gradient(
    left,
    ${({ theme }) => theme.white},
    ${({ theme }) => theme.white} 157px,
    ${({ theme }) => theme.gray4} 158px,
    ${({ theme }) => theme.gray4}
  );
  background: linear-gradient(
    left,
    ${({ theme }) => theme.white},
    ${({ theme }) => theme.white} 157px,
    ${({ theme }) => theme.gray4} 158px,
    ${({ theme }) => theme.gray4}
  );
  z-index: 1;
  margin-left: 30px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    margin: 0 !important;
    width: 100%;
    background: -webkit-linear-gradient(
      left,
      ${({ theme }) => theme.white},
      ${({ theme }) => theme.white} 71px,
      ${({ theme }) => theme.gray4} 72px,
      ${({ theme }) => theme.gray4}
    );
    background: -moz-linear-gradient(
      left,
      ${({ theme }) => theme.white},
      ${({ theme }) => theme.white} 71px,
      ${({ theme }) => theme.gray4} 72px,
      ${({ theme }) => theme.gray4}
    );
    background: linear-gradient(
      left,
      ${({ theme }) => theme.white},
      ${({ theme }) => theme.white} 71px,
      ${({ theme }) => theme.gray4} 72px,
      ${({ theme }) => theme.gray4}
    );
  }
`;
